import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ChampSourceProduitCrm } from '../model/produitCrm/ChampSourceProduitCrm';
import { TypeDocumentProduitCrm } from '../model/produitCrm/type-document-produitCrm';
import { NatureProduitCrm } from '../model/produitCrm/natureProduitCrm';
import { NatureProduitCrmChamp } from '../model/produitCrm/NatureProduitCrmChamp';
import { NatureProduitCrmDocument } from '../model/produitCrm/NatureProduitCrmDocument';
import { ProduitCrmDetail } from '../model/produitCrm/ProduitCrmDetail';
import { ProduitCrmMetadata } from '../model/produitCrm/ProduitCrmMetadata';
import { ProduitCrmDocument } from '../model/produitCrm/ProduitCrmDocument';

@Injectable({
  providedIn: "root"
})
export class ProduitCrmService {
  constructor(private _restClientService: RestClientService) {}

  getChampSourceProduitCrm() {
    return this._restClientService.load<ChampSourceProduitCrm[]>(
      "produit-crm-champs-sources/list"
    );
  }

  addChampSourceProduitCrm(typeDocument) {
    return this._restClientService.save<ChampSourceProduitCrm>(
      "produit-crm-champs-sources/add",
      typeDocument
    );
  }

  updateChampSourceProduitCrm(champSourceProduitCrmId, typeChampProduitCrm) {
    return this._restClientService.put<ChampSourceProduitCrm>(
      `produit-crm-champs-sources/update/${champSourceProduitCrmId}`,
      typeChampProduitCrm
    );
  }

  //Champs Source non encore utilisés par la natureGarantie
  getEmptyChampSourceProduitCrm(natureProduitCrmId: number) {
    return this._restClientService.load<ChampSourceProduitCrm[]>(
      "produit-crm-champs-sources/list-empty/" + natureProduitCrmId
    );
  }

  // *** Type document ***//

  getTypeDocumentProduitCrm() {
    return this._restClientService.load<TypeDocumentProduitCrm[]>(
      "produit-crm-types-documents/list"
    );
  }

  getTypeDocumentProduitCrmById(id: number) {
    return this._restClientService.load<TypeDocumentProduitCrm>(
      "produit-crm-types-documents/get/" + id
    );
  }

  addTypeDocumentProduitCrm(typeDocument) {
    return this._restClientService.save<TypeDocumentProduitCrm>(
      "produit-crm-types-documents/add",
      typeDocument
    );
  }

  updateTypeDocumentProduitCrm(typeDocumentId, typeDocument) {
    return this._restClientService.put<TypeDocumentProduitCrm>(
      `produit-crm-types-documents/update/${typeDocumentId}`,
      typeDocument
    );
  }

  deleteTypeDocumentProduitCrm(id: number) {
    return this._restClientService.delete<TypeDocumentProduitCrm>(
      `produit-crm-types-documents/delete/${id}`
    );
  }

  // nature garantie

  getAllNatureWithProduitCrmChamps() {
    return this._restClientService.load<NatureProduitCrm[]>(
      "produit-crm-natures/list-with-produit-crm-champs"
    );
  }

  getListNatureProduitCrm() {
    return this._restClientService.load<NatureProduitCrm[]>(
      "produit-crm-natures/list"
    );
  }

  getNatureProduitCrmById(natureGarantieId) {
    return this._restClientService.load<NatureProduitCrm>(
      "produit-crm-natures/get/" + natureGarantieId
    );
  }

  add(natureProduitCrm) {
    return this._restClientService.save<NatureProduitCrm>(
      "produit-crm-natures/add",
      natureProduitCrm
    );
  }

  update(natureProduitCrmId: number, natureProduitCrm) {
    return this._restClientService.put<NatureProduitCrm>(
      `produit-crm-natures/update/${natureProduitCrmId}`,
      natureProduitCrm
    );
  }

  delete(natureGarantieId: number) {
    return this._restClientService.delete<NatureProduitCrm>(
      `produit-crm-natures/delete/${natureGarantieId}`
    );
  }

  // Nature Champs garanties
  getNatureProduitCrmChamps(natureProduitCrmId: number) {
    return this._restClientService.load<NatureProduitCrmChamp[]>(
      "produit-crm-natures/champs/nature-produit-crm-id/" + natureProduitCrmId
    );
  }

  associerChamps(
    natureGarantieId: number,
    associerChamps: NatureProduitCrmChamp[]
  ) {
    return this._restClientService.save<NatureProduitCrm>(
      `produit-crm-natures/associer-champs/${natureGarantieId}`,
      associerChamps
    );
  }

  getNatureProduitCrmDocuments(natureProduitCrmId: number) {
    return this._restClientService.load<NatureProduitCrmDocument[]>(
      "produit-crm-natures/documents/nature-produit-crm-id/" +
        natureProduitCrmId
    );
  }

  addNatureProduitCrmDocument(
    document: NatureProduitCrmDocument,
    natureProduitCrmId: number
  ) {
    return this._restClientService.save<NatureProduitCrm>(
      `produit-crm-natures/add-document-to-nature-produit-crm/${natureProduitCrmId}`,
      document
    );
  }

  deleteNatureProduitCrmDocument(natureProduitCrmDocumentId: number) {
    return this._restClientService.delete<any>(
      `produit-crm-natures/delete-document-to-nature-produit-crm/${natureProduitCrmDocumentId}`
    );
  }

  //**** Produit crm add */

  getProduitCrmByRequestId(codeClient) {
    return this._restClientService.load<ProduitCrmDetail[]>(
      "produit-crm-details/list/request/" + codeClient
    );
  }

  addProduitCrmDetail(codeClient, natureProduitCrmId, produitCrm) {
    return this._restClientService.save<ProduitCrmDetail>(
      `produit-crm-details/add/dossier/${codeClient}/nature/${natureProduitCrmId}`,
      produitCrm
    );
  }

  updateProduitCrmDetail(requestId, produitCrmId, produitCrm) {
    return this._restClientService.put<ProduitCrmDetail>(
      `produit-crm-details/update/${requestId}/${produitCrmId}`,
      produitCrm
    );
  }

  deleteProduitCrmDetail(produitCrmId) {
    return this._restClientService.delete<ProduitCrmDetail>(
      `produit-crm-details/delete/${produitCrmId}`
    );
  }

  getProduitCrmDetailInfos(produitCrmId) {
    return this._restClientService.load<ProduitCrmMetadata[]>(
      "produit-crm-details/details/produit-crm-id/" + produitCrmId
    );
  }

  getProduitCrmMetadatas(garantieId) {
    return this._restClientService.load<ProduitCrmMetadata[]>(
      "produit-crm-details/metadata/garantie-id/" + garantieId
    );
  }


}
